import { Link } from 'react-router-dom';
import { comics, rankings } from '@/mocks/comics';

export default function RankingSection() {
  const getComicById = (id: number) => comics.find((c) => c.id === id);

  type RankKey = 'popularity' | 'weekly' | 'monthly';
  const rankTabs: { key: RankKey; label: string }[] = [
    { key: 'popularity', label: '人气榜' },
    { key: 'weekly', label: '周榜' },
    { key: 'monthly', label: '月榜' },
  ];

  return (
    <section className="py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门排行
          </h2>
          <div className="flex gap-1 bg-background-200 rounded-full p-1">
            {rankTabs.map((tab) => (
              <button
                key={tab.key}
                className={`px-4 py-1.5 rounded-full text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${
                  tab.key === 'popularity'
                    ? 'bg-background-50 text-foreground-900'
                    : 'text-foreground-500 hover:text-foreground-700'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankings.popularity.slice(0, 10).map((comicId, index) => {
            const comic = getComicById(comicId);
            if (!comic) return null;

            const rankColors = ['text-accent-500', 'text-accent-500', 'text-accent-600'];
            const rankBg = ['bg-accent-500', 'bg-accent-500', 'bg-accent-400/80'];

            return (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer group"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold ${
                  index < 3 ? `${rankBg[index]} text-background-50` : 'bg-background-200 text-foreground-500'
                }`}>
                  {index + 1}
                </div>
                <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover"
                    title={comic.title}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs text-accent-600">
                      <i className="ri-star-fill text-[10px]"></i> {comic.rating}
                    </span>
                    <span className="text-xs text-foreground-400">{comic.chapters}话</span>
                  </div>
                </div>
                <span className={`text-xs font-medium ${
                  comic.status === 'completed' ? 'text-accent-600' : 'text-primary-600'
                }`}>
                  {comic.status === 'completed' ? '已完结' : '连载'}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}